export const environment = {
  production: true,
  apiUrl: '/api',
  appName: 'Mitra Sanitär GmbH',
  version: '1.0.0',
  features: {
    analytics: true,
    logging: false
  }
};